
import React from 'react';
import { Ad } from '../types';
import { ExternalLink, Info } from 'lucide-react';

interface SponsoredAdCompactProps {
  ad: Ad;
}

export const SponsoredAdCompact: React.FC<SponsoredAdCompactProps> = ({ ad }) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    window.open(ad.link_url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div 
      className="flex items-center gap-4 p-3 bg-gray-50/50 dark:bg-zinc-900/30 border-b border-gray-100 dark:border-zinc-900 cursor-pointer active:bg-gray-100 dark:active:bg-zinc-800 transition-colors"
      onClick={handleClick}
    >
      {/* 35% Width Image Container */}
      <div className="w-[35%] aspect-[4/3] rounded-xl overflow-hidden relative shrink-0 shadow-sm border border-blue-100 dark:border-blue-900/20">
        <img 
          src={ad.image_url} 
          alt={ad.title} 
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute top-1.5 left-1.5">
           <span className="px-1.5 py-0.5 rounded bg-blue-600 text-[7px] font-black uppercase tracking-widest text-white shadow-lg">
             AD
           </span>
        </div>
      </div>

      {/* 65% Width Content Container */}
      <div className="w-[65%] flex flex-col justify-center min-w-0 pr-2">
        <div className="flex items-center justify-between mb-0.5">
           <div className="flex items-center gap-1">
             <span className="text-[9px] font-black text-blue-500 uppercase tracking-widest">Sponsored</span>
             <Info className="w-2.5 h-2.5 text-blue-400" />
           </div>
           <ExternalLink className="w-3.5 h-3.5 text-blue-400" />
        </div>
        
        <h3 className="text-xs font-black text-gray-900 dark:text-white truncate tracking-tight mb-1">
          {ad.title}
        </h3>
        
        <p className="text-[10px] text-gray-500 dark:text-zinc-500 font-medium leading-relaxed line-clamp-2">
          {ad.description}
        </p>
      </div>
    </div>
  );
};
